import React from 'react';
import { ArrowDown } from '@fabric-ui/icons';
import { autocompleteClasses, Popper, PopperProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AvalorSelectLoadingValue = 'avalorSelectLoadingValue';
export const DIVIDER_OPTION = 'avalorDividerOption';

export const showOnlyButtonStyle = {
  '.MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-sizeSmall': {
    paddingRight: '16px',
    input: {
      minWidth: 0,
      '+ .MuiAutocomplete-endAdornment': {
        right: '6px',
      },
    },
  },
};

export const FilterStyledPopper: React.ComponentType<PopperProps> = styled(Popper)(({ theme }) => ({
  ...((theme?.components?.MuiPaper?.styleOverrides?.rounded ?? {}) as Record<string, unknown>),
  ...((theme?.components?.MuiAutocomplete?.styleOverrides?.paper ?? {}) as Record<string, unknown>),
  backgroundColor: theme.palette.background.paper,
  zIndex: theme.zIndex.modal,
  [`& .${autocompleteClasses.popupIndicator}`]: {
    transform: 'none',
  },
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: 'none',
    padding: 0,
  },
  [`& .${autocompleteClasses.listbox}`]: {
    maxWidth: 400,
    flex: 1,
  },
}));
export const popupIcon = <ArrowDown />;
